import React,{useEffect,useState} from 'react';
import { Icon, IconButton} from '@material-ui/core';
import { SearchOutlined,AttachFile,MoreVert } from '@material-ui/icons';
import './Chat.css';
import { onSnapshot,collection, doc, serverTimestamp,addDoc } from 'firebase/firestore';
import { Avatar } from '@material-ui/core';
import styled from 'styled-components';
import MicIcon from '@material-ui/icons/Mic';
import { InsertEmoticonOutlined } from '@material-ui/icons';
import {useParams} from 'react-router-dom';
import { useDispatch,useSelector } from 'react-redux';
import { getMessages,setMessages } from './Whatsappslice';
import DB from "./Firebase";
import { query, orderBy,deleteDoc } from "firebase/firestore";  
import {getname} from './userSlice';
import {getAuth,signInWithPopup,GoogleAuthProvider} from "firebase/auth";
import {provider,auth} from './Firebase';
import {setUserOut} from './userSlice';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import Picker from 'emoji-picker-react';
import { ArrowBack } from '@material-ui/icons';
import {Link} from 'react-router-dom';
function Chat() {
  const sendername=useSelector(getname);
  const [logstate,setlogstate]=useState(false);
  const dispatch=useDispatch();
const[seed,setseed]=useState("");
var [Input,setInput] =useState("");
var [message,setmessage]=useState([]);
const {roomId} =useParams();
const selectUser=useSelector(getMessages);
const Groupname=selectUser.filter((elm)=>elm.id===roomId);
const change=(e)=>{

setInput(e.target.value);
console.log(Input);

}
const [backg,setbackg]=useState(false);


const [emoji, setemoji] = useState(false);
const [chosenEmoji, setChosenEmoji] = useState(null);

const onEmojiClick = (event, emojiObject) => {
  setChosenEmoji(emojiObject);
  setInput(Input+chosenEmoji.emoji);
  setemoji(false);
};

const emojiclick=()=>{
  if(emoji){setemoji(false);}
  else{setemoji(true);}

}


const submit=(e)=>{
  addDoc(collection(DB,"/wtrooms/"+roomId+"/wtmessages"),
  {message:Input,name:sendername,timestamp:serverTimestamp()});
e.preventDefault();
  setInput("");

}
;

const signOut=()=>{
  auth.signOut().then(()=>{dispatch(setUserOut());});
}

useEffect(()=>{

if(roomId){
const q = query(collection(DB,"/wtrooms/"+roomId+"/wtmessages"), orderBy("timestamp","asc"));

onSnapshot(q,(snap)=>{

let temp=snap.docs.map((doc)=>{return {id:doc.id,...doc.data()}});
setmessage(temp);
})}


},[roomId])

const StartSpeech=()=>{
  setbackg(true);
  const SpeechRecognition=window.SpeechRecognition || window.webkitSpeechRecognition;
  var recognition=new SpeechRecognition();
  recognition.lang="en-GB";
  recognition.onresult=function(e){
  
  setInput(e.results[0][0].transcript);
  setbackg(false);
  }
  recognition.start();
    }

const delChatItem=(chatId)=>{


deleteDoc(doc(DB,"/wtrooms/"+roomId+"/wtmessages/"+chatId));

}






useEffect(()=>{setseed(Math.floor(Math.random()*1000))},[]);
  return <div className="chat">
<div className="chat_header">
<Link to="/"><IconButton className='backIcon'><ArrowBack /></IconButton></Link>
<Avatar src={`https://avatars.dicebear.com/api/jdenticon/${seed}.svg `} />
<div className="chatheader_data">
<h3>{Groupname[0].name}</h3>
<p>{message.length!==0? "Last seen at "+ new Date(message[message.length-1].timestamp?.toDate()).toUTCString():<>Last Seen at...</>}</p>

</div>

<div className="chatheader_right">
<IconButton ><MoreVert onClick={()=>{if(logstate===false){setlogstate(true);}else{setlogstate(false);}}} className="morevert" />



</IconButton>
<button onClick={()=>{signOut();}} className={`log_out ${logstate && "logout"}`}>Sign Out</button>


</div>


</div>
<Chat_body>
  
    { message.map((elm)=>{return <p class={`chat_bodymessage ${sendername===elm.name && "chat_sender"}`}>
   <span className='chat_name'>{elm.name}</span>
   <span className='chat_del'><i class='fa fa-trash' onClick={()=>{delChatItem(elm.id);}} title="Delete"   ></i></span>
       {elm.message}
   <span className='chat_timestamp'>{new Date(elm.timestamp?.toDate()).toUTCString()}</span>
   
   </p>}) }
   {emoji ? <Picker onEmojiClick={onEmojiClick} />:<></>}
    </Chat_body>
<div className="chat_footer">
  <InsertEmoticonOutlined onClick={()=>{emojiclick();}} className="emoji"/>
  <form>
    <input type="text" placeholder='Type a Message' onChange={change} value={Input}/>
    {
      Input!=="" ? <button type="submit" onClick={submit} >Send</button> : <></>
    }
    
  </form>
  </div>
  </div>;
}

export default Chat;

const Chat_body=styled.div`
flex:1;
background-image:url('/images/whapp.png');
background-repeat:repeat;
padding:30px;
overflow:scroll;
&::-webkit-scrollbar { width: 0 !important }
`
